import { faTimes } from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@karnov/kui-react'

import { useTranslation } from 'services/i18n'

import { MessageResourceType } from 'types/MessageResourceType'

import type { FC, SyntheticEvent } from 'react'

type Props = {
  isDisabled?: boolean
  onClick: VoidFunction
  resourceType: MessageResourceType
}

export const RemoveMessageResourceButton: FC<Props> = ({ isDisabled, onClick, resourceType }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'message_resources.remove_message_resource' })

  const handleClick = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onClick()
  }

  return (
    <div className="shrink-0">
      <Button
        aria-label={t(resourceType)}
        disabled={isDisabled}
        icon={faTimes}
        isSmall
        onClick={e => handleClick(e)}
        variant="plain"
      />
    </div>
  )
}
